import {Directive, ElementRef, EventEmitter, Output, Input, OnDestroy} from '@angular/core';
import Pikaday from 'pikaday';

declare var jQuery: any;
declare var moment: any;

@Directive({
  selector: '[tpiq-custom-datepicker]',
  standalone: true
})

export class TpiqCustomDatepicker implements OnDestroy {
  picker: any;
  dateFormat: any;
  fmt: string;
  minDate: any = new Date();
  maxDate: any;
  containerElem: any;
  @Input() hideYear: boolean;
  @Output() valueChanged = new EventEmitter<any>();

  constructor(private el: ElementRef) {}

  ngOnDestroy(){
    if (this.picker){
      this.picker.destroy();
    }
  }

  @Input() set format(_format: string){
    this.fmt = _format;
  }

  @Input() set mindate(_mindate: string){
    if (_mindate == 'past'){
      this.minDate = null;
    } else if (moment(_mindate, 'MM/DD/YYYY', true).isValid()){
      this.minDate = new Date(_mindate);
    }
  }

  @Input() set maxdate(_maxDate: string){
    this.maxDate = new Date(_maxDate);
  }

  @Input() set container(container: string){
    if (container){
      this.containerElem = document.getElementById(container);
    }
  }

  ngAfterViewInit() {
    const base = this;
    const elem = jQuery(this.el.nativeElement)[0];
    this.picker = new Pikaday({ field: elem, container: this.containerElem, hideYear: this.hideYear ? this.hideYear : false, format: this.fmt ? this.fmt : 'MM/DD/YYYY', minDate: this.minDate, maxDate: this.maxDate ? this.maxDate : 'past', firstDay : 1,
      onSelect(date) {
        const dt = base.picker.toString(base.fmt || '');
        elem.value = dt;
        base.valueChanged.emit(dt as any);
        },
      onOpen(){
        if (base.containerElem && base.containerElem.children.length > 0) {
          base.containerElem.children[0].style.position = 'absolute';
        }
    }
    });
  }
}
